// import Footer from '../common/Footer'

import Footer from "../common/Footer";
import Header from "../common/Header";
import HomePage from "../pages/Home/HomePage";

function MainLayout() {
  return (
    <>
      <Header />
      <HomePage />
      <Footer />
    </>
  );
}

export default MainLayout;
